<div class="menu-container scenario">
  <div class="line editions">
    <label *ngFor="let e of editions">
      <input tabclick type="radio" name="radio" [value]="e" (change)="edition = e" [checked]="edition == e">
      <span [ghs-label]="'data.edition.' + e"></span>
    </label>
  </div>

  <div class="line">
    <label>
      <input tabclick type="checkbox" [checked]="settingsManager.settings.showAllSections"
        (change)="settingsManager.toggle('showAllSections')">
      <span [ghs-label]="'scenario.showAllSections'"></span>
    </label>
  </div>

  <ng-container *ngFor="let group of groups()">
    <div *ngIf="group && sections(group).length > 0" class="line title"><label
        [ghs-label]="'data.scenario.group.' + group"></label></div>
    <div class="line sections" *ngIf="sections(group).length > 0">
      <span tabclick *ngFor="let section of sections(group)" class="section"
        [ngClass]="{'disabled' : section.isLocked , 'available': settingsManager.settings.showAllSections && section.parent && !!gameManager.game.scenario && section.parent == gameManager.game.scenario.index && section.group == gameManager.game.scenario.group && section.edition == gameManager.game.scenario.edition}"
        [ghs-tooltip]="'scenario.tooltip'" [ghs-label-args]="[gameManager.scenarioManager.scenarioTitle(section,true)]"
        (click)="addSection(section)">
        <span *ngIf="maxSection() > 2 && section.index.length < 3">0</span>
        <span *ngIf="maxSection() > 1 && section.index.length < 2">0</span>
        {{section.index}}
      </span>
    </div>
  </ng-container>

  <div class="line disabled" *ngIf="noResults()">
    <label><span [ghs-label]="'monster.filter.noResult'"></span></label>
  </div>
</div>